export default "__VITE_ASSET__Bw1k0K_f__"